export function getApiBase(): string {
  const envUrl = import.meta.env.VITE_CMS_API_URL as string | undefined;
  const base = envUrl ? envUrl.replace(/\/$/, '') : 'https://doudou-cms-worker.jimsbond007.workers.dev';
  return base;
}
